import React from 'react';

const SvgIconCalendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M23.679 3.486h-4.875V1.629a.233.233 0 00-.232-.233h-1.625a.233.233 0 00-.232.233v1.857H9.286V1.629a.233.233 0 00-.232-.233H7.429a.233.233 0 00-.232.233v1.857H2.322a.928.928 0 00-.929.928v19.268c0 .514.415.929.929.929h21.357a.928.928 0 00.929-.929V4.414a.928.928 0 00-.929-.928zm-1.16 19.035H3.482V11.495h19.035V22.52zm-19.036-13V5.575h3.714v1.393c0 .128.104.232.232.232h1.625a.233.233 0 00.232-.232V5.575h7.429v1.393c0 .128.104.232.232.232h1.625a.233.233 0 00.232-.232V5.575h3.714v3.946H3.483z" />
  </svg>
);

export default SvgIconCalendar;
